import { LayoutDashboard, Users2 } from 'lucide-react'
import type { NavigationItem } from './types'

export const NAVIGATION_ITEMS: NavigationItem[] = [
    {
        id: 'dashboard',
        label: 'Dashboard',
        description: 'Superadmin overview metrics',
        path: '/',
        icon: LayoutDashboard,
    },
    {
        id: 'users',
        label: 'Users',
        description: 'Manage admin accounts and approvals',
        path: '/users',
        icon: Users2,
    },
]

